// UI translations for English, French, Spanish
export const LANGS = [
  { code: "en", label: "English", short: "EN" },
  { code: "fr", label: "Fran\u00e7ais", short: "FR" },
  { code: "es", label: "Espa\u00f1ol", short: "ES" },
];

const dict = {
  en: {
    tagline: "Receive the Word of God. Free, for everyone.",
    readBible: "Read the Bible online",
    randomPage: "Open a random page",
    talkAI: "Talk with the AI guide",
    askBelow: "Ask the guide below",
    speakVoice: "Speak with the voice guide",
    voiceOffline: "The voice guide connects through the live backend (xAI realtime voice). It activates automatically once deployed with a voice key.",
    sharedToday: (n) => `The word of God was shared with ${n} people today.`,
    todaysVerse: "Today\u2019s Verse",
    guideIntro: "Your guide to connect with God through His Word \u2014 ask anything, by text or voice.",
    greeting: "Peace be with you. I\u2019m here to help you explore the Bible and draw near to God. Tell me what\u2019s on your heart \u2014 or ask about any verse, person, or theme.",
    placeholder: "Ask anything, or share how you feel\u2026",
    send: "Send",
    thinking: "Seeking the Word\u2026",
    suggestions: ["I feel anxious", "Who is Jesus?", "Read John 3:16", "How do I pray?", "I\u2019m grieving", "What is the Holy Spirit?"],
    churchLead: "Looking for a church family?",
    churchDesc: "\u201cune maison pour tous,\u201d in Montr\u00e9al.",
    visit: "Visit", messages: "Messages", sundays: "Sundays \u00b7 1000 Sherbrooke O.",
    feedback: "Send feedback",
    footer1: "BibleVoice \u2014 a free digital ministry. An AI shaped by Scripture, here to point you to God \u2014 never to replace Him, His Spirit, or His Church.",
    footer2: "The complete Ethiopian Orthodox broader canon \u00b7 93 books",
    sources: "Sources & methodology", privacy: "Privacy", sourcesShort: "Sources",
    backHome: "Back to home", oldT: "Old Testament", newT: "New Testament",
    apoc: "Apocrypha \u00b7 Deuterocanon", ethio: "Ethiopian Canon", other: "Books",
    random: "Random", share: "Share", askAI: "Ask the AI", chapter: "Chapter",
    previous: "Previous", next: "Next", listen: "Listen", copied: "Link copied",
    guideTitle: "Scripture Guide", newChat: "New conversation",
  },
  fr: {
    tagline: "Recevez la Parole de Dieu. Gratuit, pour tous.",
    readBible: "Lire la Bible en ligne",
    randomPage: "Ouvrir une page au hasard",
    talkAI: "Parler avec le guide IA",
    askBelow: "Posez votre question ci-dessous",
    speakVoice: "Parler avec le guide vocal",
    voiceOffline: "Le guide vocal se connecte via le backend en ligne (voix en temps r\u00e9el xAI). Il s\u2019active automatiquement une fois d\u00e9ploy\u00e9 avec une cl\u00e9 vocale.",
    sharedToday: (n) => `La Parole de Dieu a \u00e9t\u00e9 partag\u00e9e avec ${n} personnes aujourd\u2019hui.`,
    todaysVerse: "Verset du jour",
    guideIntro: "Votre guide pour vous rapprocher de Dieu par Sa Parole \u2014 demandez tout, par texte ou par voix.",
    greeting: "La paix soit avec vous. Je suis l\u00e0 pour vous aider \u00e0 explorer la Bible et \u00e0 vous approcher de Dieu. Dites-moi ce qui est sur votre c\u0153ur.",
    placeholder: "Demandez quelque chose, ou partagez ce que vous ressentez\u2026",
    send: "Envoyer",
    thinking: "Recherche de la Parole\u2026",
    suggestions: ["Je suis anxieux", "Qui est J\u00e9sus\u00a0?", "Lire Jean 3:16", "Comment prier\u00a0?", "Je suis en deuil", "Qui est le Saint-Esprit\u00a0?"],
    churchLead: "Vous cherchez une famille d\u2019\u00e9glise\u00a0?",
    churchDesc: "\u00ab une maison pour tous \u00bb, \u00e0 Montr\u00e9al.",
    visit: "Visiter", messages: "Messages", sundays: "Dimanches \u00b7 1000 Sherbrooke O.",
    feedback: "Envoyer un commentaire",
    footer1: "BibleVoice \u2014 un minist\u00e8re num\u00e9rique gratuit. Une IA fa\u00e7onn\u00e9e par les \u00c9critures, ici pour vous orienter vers Dieu.",
    footer2: "Le canon orthodoxe \u00e9thiopien complet \u00b7 93 livres",
    sources: "Sources et m\u00e9thodologie", privacy: "Confidentialit\u00e9", sourcesShort: "Sources",
    backHome: "Retour \u00e0 l\u2019accueil", oldT: "Ancien Testament", newT: "Nouveau Testament",
    apoc: "Apocryphes \u00b7 Deut\u00e9rocanon", ethio: "Canon \u00e9thiopien", other: "Livres",
    random: "Al\u00e9atoire", share: "Partager", askAI: "Demander \u00e0 l\u2019IA", chapter: "Chapitre",
    previous: "Pr\u00e9c\u00e9dent", next: "Suivant", listen: "\u00c9couter", copied: "Lien copi\u00e9",
    guideTitle: "Guide des \u00c9critures", newChat: "Nouvelle conversation",
  },
  es: {
    tagline: "Recibe la Palabra de Dios. Gratis, para todos.",
    readBible: "Leer la Biblia en l\u00ednea",
    randomPage: "Abrir una p\u00e1gina al azar",
    talkAI: "Hablar con el gu\u00eda IA",
    askBelow: "Pregunta al gu\u00eda abajo",
    speakVoice: "Hablar con el gu\u00eda de voz",
    voiceOffline: "El gu\u00eda de voz se conecta a trav\u00e9s del backend en vivo (voz en tiempo real de xAI). Se activa autom\u00e1ticamente al desplegarse con una clave de voz.",
    sharedToday: (n) => `La Palabra de Dios se comparti\u00f3 con ${n} personas hoy.`,
    todaysVerse: "Versículo de hoy",
    guideIntro: "Tu gu\u00eda para conectar con Dios a trav\u00e9s de Su Palabra \u2014 pregunta lo que sea, por texto o voz.",
    greeting: "La paz sea contigo. Estoy aqu\u00ed para ayudarte a explorar la Biblia y acercarte a Dios. Dime qu\u00e9 hay en tu coraz\u00f3n.",
    placeholder: "Pregunta algo, o comparte c\u00f3mo te sientes\u2026",
    send: "Enviar",
    thinking: "Buscando la Palabra\u2026",
    suggestions: ["Me siento ansioso", "\u00bfQui\u00e9n es Jes\u00fas?", "Leer Juan 3:16", "\u00bfC\u00f3mo oro?", "Estoy de duelo", "\u00bfQui\u00e9n es el Esp\u00edritu Santo?"],
    churchLead: "\u00bfBuscas una familia de iglesia?",
    churchDesc: "\u201cuna casa para todos\u201d, en Montreal.",
    visit: "Visitar", messages: "Mensajes", sundays: "Domingos \u00b7 1000 Sherbrooke O.",
    feedback: "Enviar comentarios",
    footer1: "BibleVoice \u2014 un ministerio digital gratuito. Una IA formada por las Escrituras, aqu\u00ed para se\u00f1alarte a Dios.",
    footer2: "El canon ortodoxo et\u00edope completo \u00b7 93 libros",
    sources: "Fuentes y metodolog\u00eda", privacy: "Privacidad", sourcesShort: "Fuentes",
    backHome: "Volver al inicio", oldT: "Antiguo Testamento", newT: "Nuevo Testamento",
    apoc: "Apócrifos \u00b7 Deuterocan\u00f3nicos", ethio: "Canon et\u00edope", other: "Libros",
    random: "Aleatorio", share: "Compartir", askAI: "Preguntar a la IA", chapter: "Cap\u00edtulo",
    previous: "Anterior", next: "Siguiente", listen: "Escuchar", copied: "Enlace copiado",
    guideTitle: "Gu\u00eda de las Escrituras", newChat: "Nueva conversaci\u00f3n",
  },
};

export function t(lang, key, ...args) {
  const l = dict[lang] || dict.en;
  const v = l[key] !== undefined ? l[key] : dict.en[key];
  return typeof v === "function" ? v(...args) : v;
}
